module.exports = __webpack_public_path__ + "img/login-rafiki.b5a52196.svg";